var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.558 11.836l-.001.003-.002-.004-3.551 1.259.002.008H18v7.892h.007l-.005.008L22.1 23.51l.001-.002.001.002 3.893-2.013-.003-.006h.006v-7.68l.004-.01zm.073 10.215L19 20.44v-5.872l2.63 1.164zm-2.22-8.395l2.104-.745 2.753 1.218-2.104.745zm5.586 7.232l-2.366 1.223v-5.23l1.64 1.027.003-.004.011.007.712-1.112zm0-5.944l-1.023 1.598-1.274-.797 2.298-.814zm-9.002-3.731L13.18 7.74V6.682L8.9 7.993V8.8l-2.892 1.744H6v10.164l-.005.008 4.828 2.956.004-.008.006.01 5.162-2.67-.001-.003H16v-9.787h-.006zM8.98 9.917l.928 1.986-2.426-1.087zm1.38 12.3L7 20.158v-8.463l3.36 1.505zm-.403-12.57l2.87-.883 1.941 2.528-3.562 1.028zM15 20.393l-3.64 1.882v-8.96l3.64-1.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--cardboard-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'CardboardCircleIcon';
export default Icon;